import { render, staticRenderFns } from "./TheUpsertStockProfile.vue?vue&type=template&id=6b868328"
import script from "./TheUpsertStockProfile.vue?vue&type=script&lang=ts"
export * from "./TheUpsertStockProfile.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports